import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// tiny helper for FormData uploads
export const uploadCsv = async (path, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(path, form, { headers: { "Content-Type": "multipart/form-data" } });
};
